"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRenderingComments = isRenderingComments;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ccxComments = require("@ccx-public/ccx-comments");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useShare2 = _interopRequireDefault(require("../hooks/useShare"));

require("../App.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Determines if comments should currently be rendered.
 * @param {Object} props - props that will be passed to CommentsProvider
 * @return {Boolean} - to indicate if should be rendered.
 */
function isRenderingComments(_ref) {
  var isOffline = _ref.isOffline,
      imsData = _ref.imsData,
      isDocumentActive = _ref.isDocumentActive,
      appKey = _ref.appKey;
  return Boolean((isOffline || imsData && imsData.id) && isDocumentActive && appKey);
}
/**
 * CCX Comments Web Page for a host app to load
 * in order to interact with the Share Sheet component.
 * @param {Object} props - props for provider.
 * @returns {HTMLElement} - Rendered commenting component.
 */


var App = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$assetData;

  var providerRef = _react["default"].useRef();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isRegistered = _useState2[0],
      setIsRegistered = _useState2[1];

  var _useShare = (0, _useShare2["default"])((_props$assetData = props.assetData) === null || _props$assetData === void 0 ? void 0 : _props$assetData.id, props.appKey, props.environment, props.imsData),
      shareStatus = _useShare.shareStatus,
      shareStatusIsLoading = _useShare.isLoading,
      reconfigureShareStatus = _useShare.reconfigureShareStatus,
      ownerId = _useShare.ownerId;

  var assetData = (0, _react.useMemo)(function () {
    var _props$assetData2;

    var newAssetData = _objectSpread({}, props.assetData);

    if (!((_props$assetData2 = props.assetData) !== null && _props$assetData2 !== void 0 && _props$assetData2.ownerId)) {
      newAssetData.ownerId = ownerId;
    }

    return newAssetData;
  }, [props.assetData, ownerId]);
  var callbackRef = (0, _react.useCallback)(function (node) {
    providerRef.current = node;

    if (node !== null && node !== void 0 && node.registerAnnotationSection && !isRegistered) {
      node.registerAnnotationSection();
      setIsRegistered(true);
    }
  }, [isRegistered]);
  (0, _react.useImperativeHandle)(ref, function () {
    if (providerRef.current) {
      return _objectSpread(_objectSpread({}, providerRef.current), {}, {
        reconfigureShareStatus: reconfigureShareStatus
      });
    }

    return null;
  });

  if (!isRenderingComments(props)) {
    return null;
  }

  var platform = (props.platform || '').toLowerCase();

  if (platform.includes('mac')) {
    platform = 'mac';
  } else if (platform.includes('win')) {
    platform = 'win';
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "comments-app ".concat(platform, " ").concat(props.locale),
    "data-testid": "app"
  }, /*#__PURE__*/_react["default"].createElement(_ccxComments.CommentsProvider, _extends({}, props, {
    assetData: assetData,
    isLoading: shareStatusIsLoading,
    shareStatus: shareStatus,
    ref: callbackRef
  }), /*#__PURE__*/_react["default"].createElement(_ccxComments.CommentsFull, null)));
});

App.defaultProps = {
  appKey: undefined,
  appName: undefined,
  assetData: undefined,
  environment: 'stage',
  imsData: undefined,
  isDocumentActive: false,
  locale: undefined,
  platform: undefined,
  theme: 'light'
};
App.propTypes = {
  appKey: _propTypes["default"].string,
  appName: _propTypes["default"].string,
  assetData: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    ownerId: _propTypes["default"].string,
    nodeId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    region: _propTypes["default"].string,
    url: _propTypes["default"].string,
    validNodes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].string.isRequired,
      pageTitle: _propTypes["default"].string,
      subtitle: _propTypes["default"].string
    }))
  }),
  environment: _propTypes["default"].string,
  isDocumentActive: _propTypes["default"].bool,
  theme: _propTypes["default"].string,
  imsData: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    token: _propTypes["default"].string
  }),
  locale: _propTypes["default"].string,
  platform: _propTypes["default"].string
};
App.displayName = 'App';
var _default = App;
exports["default"] = _default;